import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  withRouter,
} from "react-router-dom";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import GeneralBloc from "../../../bloc/general_bloc";
import "./app_notice_dialog.css";
import "./app_track_dialog.css";

class AppTrackDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      additionalEmail: "",
      comment: "",
      refs: {
        additionalEmail: React.createRef(),
        comment: React.createRef(),
        filterFieldsDropDownKey: Math.random(),
        filterFieldsList: [],
        filterFieldsDropDownValues: "",
        roleList: [],
        selectedRole: "",
        rolesDropDownKey: Math.random()
      }
    }
  }

  propTitle() {
    return this.props.title;
  }
  propSubTitle() {
    return this.props.subTitle;
  }
  propPositiveButton() {
    return this.props.positiveButton;
  }
  propNegativeButton() {
    return this.props.negativeButton;
  }

  propShowClose() {
    return this.props.showClose || false;
  }

  onValidateReject() {
    return this.state.comment.length > 0;
  }

  stateFilterFieldsList() {
    return this.state.filterFieldsList || []
  }

  stateRoleList() {
    return this.state.roleList || []
  }

  componentDidMount() {
  }

  render() {
    return (
      <Modal
        backdrop="static"
        centered
        style={{ maxWidth: "480px" }}
        isOpen={this.props.isOpen}
      >
        <ModalBody>
          {this.propShowClose() == true && (
            <div style={{ "text-align": "right", marginBottom: "-50px" }}>
              <div>
                <img
                  src={
                    GeneralBloc.getAssetsContextPath() +
                    "/assets/images/Clear_Icon.svg"
                  }
                  className="terms_and_condition_close_button"
                  onClick={() => this.props.onCloseDialog("no")}
                />
              </div>
            </div>
          )}
          <div className="row no-gutters notice_modal_content">
            <div className="col-md-12 text-left">
              <div className="track_error_title">
                Track Errors<span> <br/>
                  <div className="track_error_filename">
                  {
                    this.props.trackErrorsList && this.props.trackErrorsList[0]?.fileName ? this.props.trackErrorsList[0]?.fileName:"-"
                  }
                  </div>                  
                </span>
              </div>
              {/* Contents in columns */}
              {
                this.props.trackErrorsList && this.props.trackErrorsList.length > 0 && this.props.trackErrorsList.map((item, pos) => {
                  return <div className="track_error_item">
                    {pos + 1}. {item?.properties?.agentName || "-"}<span> - {item?.properties?.agentId || "-" }</span><br />
                    <span>{item?.description}</span>
                  </div>
                })

              }

            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
export default withRouter(AppTrackDialog);
